/*
* 口数割り当て
*/

import NumberFieldsCount from '../numberFieldsCount/index';

export default class NumberFieldsAssign {
  constructor() {
    // 割当済口数	
    this.$numberFields = document.querySelectorAll('[data-target="numberFields"]');
    // 追加割当口数
    this.$addedNumberFields = document.querySelectorAll('[data-target="addedNumberFields"]');
    this.$assignFlgs = document.querySelectorAll('[data-target="assignFlg"]');
    this.$totalLimit = document.getElementById('totalLimit');
    // 下限口数
    this.$minInvestmentUnit = document.getElementById('minInvestmentUnit');
  }

  attachEvent() {
    const assignButton = document.getElementById('autoAssignButton');
    const clearButton = document.getElementById('clearAssignButton');
    if (assignButton) {
      assignButton.addEventListener('click', () => {
        executeAssign();
      });
      clearButton.addEventListener('click', () => {
        clearAssign();
      });
    }

    function getRemainingCount(numberFields, addedNumberFields, totalLimit) {
      let currentAssignedNumber = numberFields.reduce(function(previousValue, currentValue, index) {
        return previousValue + Number(currentValue.value) + Number(addedNumberFields[index].value);
      }, 0);
      return Number(totalLimit - currentAssignedNumber);
    }

    function isConfirmedAssign(lockedApplicationIds, applicationId) {
      return (lockedApplicationIds.includes(applicationId));
    }

    function getRandomAssignFields(numberFields, lockedApplicationIds) {
      let randomAssignFields = numberFields.filter(numberField =>
        !isConfirmedAssign(lockedApplicationIds, numberField.dataset.applicationId)
      );
      return randomAssignFields;
    }

    function getLockedApplicationIds(assignFlgs) {
      const filteredAssignFlgs = assignFlgs.filter(assignFlg => assignFlg.checked);
      return filteredAssignFlgs.map(assignFlg => assignFlg.value);
    }

    // Fisher–Yates shuffle
    function shuffle(array) {
      let n = array.length, t, i;
      while (n) {
        i = Math.floor(Math.random() * n--);
        t = array[n];
        array[n] = array[i];
        array[i] = t;
      }
      return array;
    }

    function addFlgElement() {
      if (document.getElementById('autoAssigned') === null) {
        let flgElement = document.createElement('div');
        flgElement.id = 'autoAssigned';
        document.body.appendChild(flgElement);
      }
    }


    function findAddedNumberField(addedNumberFields, applicationId) {
      return addedNumberFields.find(addedNumberField =>
        addedNumberField.dataset.applicationId == applicationId
      );
    }


    // ランダム振り分けを実行する
    function executeAssign() {
      // 追加割当口数フィールドのクリアの実行
      clearAssign();
      // インスタンスを再生成して情報取得・セット
      const instance = new NumberFieldsAssign();
      // 割当済工数
      const numberFields = Object.values(instance.$numberFields);
      // 追加割当工数
      const addedNumberFields = Object.values(instance.$addedNumberFields);

      const assignFlgs = Object.values(instance.$assignFlgs);
      const totalLimit = Number(instance.$totalLimit.dataset.target);
      // 下限口数
      const minInvestmentUnit = Number(instance.$minInvestmentUnit.dataset.target);

      // 振り分け対象となるnumberFieldsの配列をシャッフルする
      const lockedApplicationIds = getLockedApplicationIds(assignFlgs);
      const randomAssignFields = getRandomAssignFields(numberFields, lockedApplicationIds);
      const shuffledFields = shuffle(randomAssignFields);

      // 割り振る口数
      let remaining = getRemainingCount(numberFields, addedNumberFields, totalLimit);

      // シャッフルしたものに口数を割り当てる
      shuffledFields.forEach(function (field) {
        if (remaining < minInvestmentUnit) return true;

        // 最大割当口数 = 応募口数 - 割当済口数
        const maximumAssign = Number(field.dataset.applicationLimit) - field.value;

        // 追加割当工数に割り当てる
        let addedField = findAddedNumberField(addedNumberFields, field.dataset.applicationId);
        if (maximumAssign > remaining) {
          addedField.value = remaining;
        } else {
          addedField.value = maximumAssign;
        }

        remaining -= Number(addedField.value);
      });

      // 残り口数再計算のフラグ用のエレメントを追加して再実行
      addFlgElement();
      new NumberFieldsCount().attachEvent();
    }

    // フィールドのクリアの実行
    function clearAssign() {
      // インスタンスを再生成して情報取得・セット
      const instance = new NumberFieldsAssign();
      const addedNumberFields = Object.values(instance.$addedNumberFields);
      const assignFlgs = Object.values(instance.$assignFlgs);
      const lockedApplicationIds = getLockedApplicationIds(assignFlgs);
      let randomAssignFields = getRandomAssignFields(addedNumberFields, lockedApplicationIds);

      randomAssignFields.forEach(function(field) {
        field.value = 0;
      });

      addFlgElement();
      new NumberFieldsCount().attachEvent();
    }
  }
}
